import React, { Component } from "react";
import "../css/Home.css";
import logo from "../Images/loader.gif";
import Header from "./CHeader";
import {
    PostMembers,
    GetAccountsMembers,
    GetAccountsOwners,
    GetAccountsMembersAndOwners,
} from "../Service";
import TeamList from "./TeamList";
import _ from "lodash-es";
import { Button, Modal } from "react-bootstrap";
import PaginationComponent from "react-reactstrap-pagination";
import {
    ProcessCsvError,
    setMemberPropertyErrorCatch,
    removeMemberErrorCatch,
    addRowErrorCatch,
    CsvDataLoadFormSuccess,
    CsvEmptyValueWarning,
    CsvDuplicateValueWarning,
    CsvInvalidFormatError,
    CsvEmptyFileError,
    addMemberError,
    copyStringLink,
    CsvExportError,
    selfServiceMemberAddSuccess,
    notSelectedTeamError,
    addMemberOwnerSuccess,
    addOwnerError0,
    addOwnerError1,
    addOwnerSkippedSuccess,
    addOwnerSuccess,
    lastNameInvalidValidError,
    displayNameLength,
    emailInvalidLengthError,
    emailWithTenantDomainError,
    emailInvalidValidError,
    emailDuplicateError,
    firstNameLength,
    firstNameInvalidValidError,
    lastNameLength,
    addRemovedMemberOwnerConfirmation,
    addRemovedMemberOwnerSuccess,
    notSeeingTeamsInfo,
    firstNameRequiredError,
    lastNameRequiredError,
    displayNameRequiredError,
    emailRequiredError,
    countryNotFoundError,
    tenantDomain,
    amtDocsUrl,
    companyLength,
    companyRequiredError,
    companyRequired
} from "../message";
import CAlert from "./CAlert";
import { Tab, Tabs } from "react-bootstrap";
import { MembersList } from "./MembersList";
import * as PapaParse from "papaparse";
import countryJson from "./country.json";
import { CSVLink } from "react-csv";
import List from "react-virtualized/dist/commonjs/List";
const emailRegexToCheckSpl = /^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/;
const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const regex = new RegExp("^[a-zA-Z()À-ÖØ-öø-ÿ ,.]+$");
const lastnameregex = new RegExp("^[a-zA-Z()À-ÖØ-öø-ÿ ,.-]+$");
interface IState {
    removedGroupMembers: Array<any>;
    removedGroupOwners: Array<any>;
    members: Array<any>;
    uploadedFile: any;
    loading: boolean;
    emailvalidation: boolean;
    showcontent: string;
    selectedgroupid: string;
    showbulkcontent: string;
    alertmessage: string;
    showalert: boolean;
    alerttype: string;
    alertheading: string;
    tabselected: number;
    type: string;
    keychanged: boolean;
    activeTab: any;
    addLicenses: number;
    addRemoved: boolean;
    accept: boolean;
    showWarning: boolean;
    ownersCount: number;
    copyLink: string;
    EditingRowInd: number;
    selectedGroup: any;
    groupMembers: Array<any>;
    groupOwners: Array<any>;
    pageSize: number;
    selectedPage: number;
    currentMembers: Array<any>;
}
interface IProps {
    match: any;
    styleName: string;
}

export class Home extends Component<IProps, IState> {
    private uploadedFileRef?: React.RefObject<HTMLInputElement>;
    private tableRef?: React.RefObject<List>;

    constructor(props: IProps) {
        super(props);
        this.uploadedFileRef = React.createRef();
        this.tableRef = React.createRef();
        if (!localStorage.getItem("showcontent")) {
            localStorage.setItem("showcontent", "show");
        }
        if (!localStorage.getItem("showbulkcontent")) {
            localStorage.setItem("showbulkcontent", "show");
        }
        this.state = {
            removedGroupMembers: [],
            removedGroupOwners: [],
            members: [
                {
                    firstName: "",
                    lastName: "",
                    displayname: "",
                    email: "",
                    country: "",
                    company: "",
                    speakersGroup: "false",
                    attendeesGroup: "false",
                    organizersGroup: "false",
                    sponsersGroup: "false",
                },
            ],
            uploadedFile: null,
            loading: false,
            emailvalidation: false,
            showcontent: localStorage.getItem("showcontent") || "show",
            selectedgroupid: "",
            showbulkcontent: localStorage.getItem("showbulkcontent") || "show",
            alertheading: "",
            alertmessage: "",
            alerttype: "",
            showalert: false,
            tabselected: 1,
            type: "Members",
            keychanged: true,
            activeTab: "Add Members & Guests",
            addLicenses: 0,
            addRemoved: false,
            accept: false,
            showWarning: false,
            ownersCount: 0,
            copyLink: "",
            EditingRowInd: 0,
            selectedGroup: null,
            groupOwners: [],
            groupMembers: [],
            pageSize: 10,
            selectedPage: 1,
            currentMembers: [
                {
                    firstName: "",
                    lastName: "",
                    displayname: "",
                    email: "",
                    country: "",
                    company: "",
                    speakersGroup: "false",
                    attendeesGroup: "false",
                    organizersGroup: "false",
                    sponsersGroup: "false",
                },
            ],
        };
        this.postSelfAcceptance = this.postSelfAcceptance.bind(this);
        this.acceptSelf = this.acceptSelf.bind(this);
        this.setMemberProperty = this.setMemberProperty.bind(this);
        this.removeMember = this.removeMember.bind(this);
        this.checkEmail = this.checkEmail.bind(this);
        this.addRow = this.addRow.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.extractData = this.extractData.bind(this);
        this.handlePostMembers = this.handlePostMembers.bind(this);
        this.getDisabled = this.getDisabled.bind(this);
        this.showContent = this.showContent.bind(this);
        this.showBulkContent = this.showBulkContent.bind(this);
        this.setGroupid = this.setGroupid.bind(this);
        this.setalertparameters = this.setalertparameters.bind(this);
        this.onResetGroupId = this.onResetGroupId.bind(this);
        this.handleLoading = this.handleLoading.bind(this);
        this.postData = this.postData.bind(this);
        this.showWarning = this.showWarning.bind(this);
        this.getOwnerCount = this.getOwnerCount.bind(this);
        this.loadTeamInfo = this.loadTeamInfo.bind(this);
        this.mapAccountsToUsers = this.mapAccountsToUsers.bind(this);
    }

    setMemberProperty(index: number, key: string, value: string) {
        try {
            this.setState({ keychanged: false });
            let members = this.state.members.map((member, inx) =>
                index === inx ? { ...member, [key]: value } : member
            );
            if (key === "email") {
                members.map((x: any) => (x.duplicateemail = false));
                if (
                    this.state.members.findIndex(
                        (x) => x.email.toLocaleLowerCase() === value.toLocaleLowerCase()
                    ) !== -1
                ) {
                    members[index].duplicateemail = true;
                }
            }
            let keychanged = this.getDisabled(members);
            this.setState(
                {
                    members: members,
                    keychanged: keychanged,
                    EditingRowInd: index,
                },
                () => {
                    if (key === "email") {
                        this.checkEmail();
                    }
                }
            );
        } catch {
            this.setalertparameters(
                `${setMemberPropertyErrorCatch}`,
                "error",
                "Error"
            );
        }
    }

    checkEmail = () => {
        let memberList = [...this.state.members];
        let memberListCopy: Array<any> = [];
        memberList.map((member) => {
            const duplicateEmailIndex = memberListCopy.findIndex(
                (item: any) => item.email?.toLowerCase() === member.email?.toLowerCase()
            );
            if (duplicateEmailIndex !== -1) {
                memberListCopy = [
                    ...memberListCopy,
                    { ...member, duplicateemail: true },
                ];
                memberListCopy[duplicateEmailIndex] = {
                    ...memberListCopy[duplicateEmailIndex],
                    duplicateemail: true,
                };
            } else {
                memberListCopy = [
                    ...memberListCopy,
                    { ...member, duplicateemail: false },
                ];
            }
            return "";
        });

        this.setState({ members: memberListCopy });
    };

    removeMember(index: number) {
        try {
            let members = this.state.members.filter((_mem, inx) => inx !== index);
            let keychanged = this.getDisabled(members);
            this.setState(
                {
                    members: members,
                    keychanged: keychanged,
                },
                () => {
                    this.checkEmail();
                }
            );
        } catch {
            this.setalertparameters(`${removeMemberErrorCatch}`, "error", "Error");
        }
    }

    addRow() {
        try {
            const selectPage = Math.ceil(
                (this.state.members.length + 1) / this.state.pageSize
            );
            this.setState({
                members: [
                    ...this.state.members,
                    {
                        firstName: "",
                        lastName: "",
                        displayname: "",
                        email: "",
                        country: "",
                        company: "",
                        speakersGroup: "false",
                        attendeesGroup: "false",
                        organizersGroup: "false",
                        sponsersGroup: "false",
                    },
                ],
                selectedPage: selectPage,
            });
        } catch {
            this.setalertparameters(`${addRowErrorCatch}`, "error", "Error");
        }
    }

    handleFiles(file: File) {
        try {
            this.handleLoading(true);
            let reader = new FileReader();
            let csvData: any;
            let that = this;
            reader.readAsText(file);
            reader.onloadend = (_event: Event) => {
                csvData = PapaParse.parse(
                    reader.result as string,
                    Object.assign({} as PapaParse.ParseConfig, {
                        encoding: "UTF-8",
                    })
                );
                that.extractData(csvData?.data ?? []);
            };
        } catch {
            this.setalertparameters(`${ProcessCsvError}`, "error", "Error");
            if (this.uploadedFileRef && this.uploadedFileRef.current)
                this.uploadedFileRef.current.value = "";
        }
    }

    showContent() {
        if (localStorage.getItem("showcontent") === "show") {
            localStorage.setItem("showcontent", "hide");
        } else {
            localStorage.setItem("showcontent", "show");
        }
        this.setState({
            showcontent: localStorage.getItem("showcontent") || "show",
        });
    }

    showBulkContent() {
        if (localStorage.getItem("showbulkcontent") === "show") {
            localStorage.setItem("showbulkcontent", "hide");
        } else {
            localStorage.setItem("showbulkcontent", "show");
        }
        this.setState({
            showbulkcontent: localStorage.getItem("showbulkcontent") || "show",
        });
    }

    extractData(data: Array<any>) {
        try {
            data = data.filter((x) => x.length === 10);
            if (data.length)
                data[0] = data[0].map((row: string) => row.replace(/[^a-zA-Z 0-9]+/g, ""));
            let invalidarray: any = [];
            if (
                data.length >= 2 &&
                data[0][0].toLowerCase() === "first name" &&
                data[0][1].toLowerCase() === "last name" &&
                data[0][2].toLowerCase() === "display name" &&
                data[0][3].toLowerCase() === "email" &&
                data[0][4].toLowerCase() === "country" &&
                data[0][5].toLowerCase() === "company" &&
                data[0][6].toLowerCase() === "speakers group" &&
                data[0][7].toLowerCase() === "attendees group" &&
                data[0][8].toLowerCase() === "organizers group" &&
                data[0][9].toLowerCase() === "sponsors group"

            ) {
                this.setalertparameters(
                    `${CsvDataLoadFormSuccess}`,
                    "success",
                    "Success"
                );
                data.splice(0, 1);
                let csvData = data.map((row) => {
                    return {
                        firstName: row[0].trim(),
                        lastName: row[1].trim(),
                        displayname: row[2].trim(),
                        email: row[3].trim(),
                        country: this.findCountryCodeFromList(row[4].trim()),
                        company: row[5].trim(),
                        speakersGroup: row[6].toLowerCase().trim() === "yes" ? "true" : "false",
                        attendeesGroup: row[7].toLowerCase().trim() === "yes" ? "true" : "false",
                        organizersGroup: row[8].toLowerCase().trim() === "yes" ? "true" : "false",
                        sponsersGroup: row[9].toLowerCase().trim() === "yes" ? "true" : "false",
                    };
                });
                let nodata = csvData.filter(
                    (x) => !x.email || !x.firstName || !x.lastName
                );
                if (nodata.length > 0) {
                    this.setalertparameters(
                        `${CsvEmptyValueWarning}`,
                        "warning",
                        "Warning"
                    );
                    if (this.uploadedFileRef && this.uploadedFileRef.current)
                        this.uploadedFileRef.current.value = "";
                } else {
                    invalidarray = csvData.filter(
                        (x) =>
                            (x.email &&
                                (!(
                                    emailregex.test(x.email) && emailRegexToCheckSpl.test(x.email)
                                ) ||
                                    x.email.toLowerCase().includes("@" + `${tenantDomain}`))) ||
                            !regex.test(x.firstName) ||
                            !lastnameregex.test(x.lastName)
                    );

                    let unique = csvData
                        .map((item) => item.email)
                        .filter((value, index, self) => self.indexOf(value) === index);
                    if (unique.length === csvData.length) {
                        let previousdata = [...this.state.members];
                        previousdata = previousdata.filter(
                            (x) => x.firstName || x.lastName || x.email
                        );
                        if (previousdata.length > 0) {
                            let finaldata = [...previousdata, ...csvData];
                            this.setState({
                                members: _.uniqBy(finaldata, "email"),
                                keychanged: invalidarray.length ? true : false,
                            });
                        } else if (csvData.length > 0) {
                            this.setState({
                                members: [...csvData],
                                keychanged: invalidarray.length ? true : false,
                            });
                        }
                        if (this.uploadedFileRef && this.uploadedFileRef.current)
                            this.uploadedFileRef.current.value = "";
                    } else {
                        this.setalertparameters(
                            `${CsvDuplicateValueWarning}`,
                            "warning",
                            "Warning"
                        );
                        if (this.uploadedFileRef && this.uploadedFileRef.current)
                            this.uploadedFileRef.current.value = "";
                    }
                }
            } else {
                if (data.length === 0) {
                    this.setalertparameters(`${CsvInvalidFormatError}`, "error", "Error");
                } else if (data.length > 1 && data[0].length % 10 !== 0) {
                    this.setalertparameters(`${CsvInvalidFormatError}`, "error", "Error");
                } else if (
                    (data.length >= 2 &&
                        data[0].length === 10 &&
                        (data[0][0].toLowerCase() !== "first name" ||
                            data[0][1].toLowerCase() !== "last name" ||
                            data[0][2].toLowerCase() !== "display name" ||
                            data[0][3].toLowerCase() !== "email" ||
                            data[0][4].toLowerCase() !== "country" ||
                            data[0][5].toLowerCase() !== "company" ||
                            data[0][6].toLowerCase() !== "speakers group" ||
                            data[0][7].toLowerCase() !== "attendees group" ||
                            data[0][8].toLowerCase() !== "organizers group" ||
                            data[0][9].toLowerCase() !== "sponsors group")) ||

                    data[0].length !== 11
                ) {
                    this.setalertparameters(`${CsvInvalidFormatError}`, "error", "Error");
                } else if (
                    data.length === 1 &&
                    data[0][0].toLowerCase() === "first name" &&
                    data[0][1].toLowerCase() === "last name" &&
                    data[0][2].toLowerCase() === "display name" &&
                    data[0][3].toLowerCase() === "email" &&
                    data[0][4].toLowerCase() === "country" &&
                    data[0][5].toLowerCase() === "company" &&
                    data[0][6].toLowerCase() === "speakers group" &&
                    data[0][7].toLowerCase() === "attendees group" &&
                    data[0][8].toLowerCase() === "organizers group" &&
                    data[0][9].toLowerCase() === "sponsors group"

                ) {
                    this.setalertparameters(`${CsvEmptyFileError}`, "error", "Error");
                } else {
                    this.handleLoading(false);
                }
                if (this.uploadedFileRef && this.uploadedFileRef.current)
                    this.uploadedFileRef.current.value = "";
            }
        } catch {
            this.setalertparameters(`${ProcessCsvError}`, "error", "Error");
        }
    }

    async postData() {
        let isRemovedEmailsExisit: boolean = false;

        this.state.removedGroupMembers.map((data: any) => {
            let isEmailExisit = this.checkIfExistence(data.title);
            if (isEmailExisit) {
                isRemovedEmailsExisit = isEmailExisit;
            }
            return isEmailExisit;
        });
        if (!isRemovedEmailsExisit) {
            this.state.removedGroupOwners.map((data: any) => {
                let isEmailExisit = this.checkIfExistence(data.title);
                if (isEmailExisit) {
                    isRemovedEmailsExisit = isEmailExisit;
                }
                return isEmailExisit;
            });
        }
        if (isRemovedEmailsExisit) {
            this.setState({ addRemoved: true });
        } else this.handlePostMembers();
    }

    public checkIfExistence(email: string): boolean {
        return this.state.members.some((r) => r.email === email);
    }

    getOwnerCount(owners: Array<any>) {
        const activeOwners = owners.filter(
            (owner: any) => owner.status !== "Removed"
        ).length;
        this.setState({ ownersCount: activeOwners });
    }

    async handlePostMembers() {
        try {
            this.setState({ loading: true, addRemoved: false });

            let filteredData = this.state.members.map((member: any) => {
                return {
                    ...member,
                    firstName: member.firstName.trim(),
                    displayname: member.displayname.trim(),
                    lastName: member.lastName.trim(),
                    email: member.email.trim(),
                    company: member.company.trim(),
                };
            });

            filteredData = filteredData.filter(
                (member) =>
                    member.firstName !== "" &&
                    member.displayname !== "" &&
                    member.lastName !== "" &&
                    member.email !== "" &&
                    (companyRequired ? member.company !== "" : true)
            );
            filteredData = filteredData.map((mem) =>
                this.findCountryCodeFromList(mem.country) === "Not Found"
                    ? { ...mem, country: "" }
                    : mem
            );
            if (filteredData.length > 0) {
                let type = this.state.activeTab.toLowerCase().includes("members")
                    ? "Member"
                    : "Owner";
                for (var index = 0; index < filteredData.length; index++) {
                    filteredData[index].country = this.findCountryCodeFromListNew(
                        filteredData[index].country
                    );
                    if (filteredData[index].country === "")
                        filteredData[index].country = "US";
                }

                await PostMembers(
                    filteredData,
                    this.state.selectedgroupid,
                    `${type}s`
                ).subscribe((response: any) => {
                    if (response.status === "Error") {
                        this.setalertparameters(response.message, "error", "Error");
                        return;
                    }
                    if (response?.status === 200 || response?.status === 204) {
                        let addedEmailsCount = filteredData.length - response.data.length;
                        let skippedUsers = response.data.filter(
                            (x: any) => x.status === "Skipped"
                        );
                        let skippedEmailsCount = skippedUsers.length;
 
                        const accessTypeCounts: { [key: string]: number } = {};
                        const accessTypes = ["Member", "Owner", "Guest"];
                        accessTypes.forEach((type) => {
                            const skippedCount = skippedUsers.filter((x:any) => x.accessType === type).length;
                            if (skippedCount > 0) {
                                accessTypeCounts[type] = skippedCount;
                            }
                        });
                        let UpdatedEmailsCount = response.data.filter(
                            (x: any) => x.status === "Updated"
                        ).length;
                        if (response.data.length === 0) {
                            this.setalertparameters(
                                addMemberOwnerSuccess
                                    .replace("{count}", `${addedEmailsCount}`),
                                "success",
                                "Success"
                            );
                            this.setState(
                                {
                                    members: [
                                        {
                                            firstName: "",
                                            lastName: "",
                                            displayname: "",
                                            email: "",
                                            country: "",
                                            company: "",
                                            speakersGroup: "false",
                                            attendeesGroup: "false",
                                            organizersGroup: "false",
                                            sponsersGroup: "false",
                                            IsEdited: false,
                                        },
                                    ],
                                    keychanged: true,
                                },
                                () => {
                                    this.tableRef?.current?.forceUpdateGrid();
                                }
                            );
                        } else if (
                            response.data.length === 1 &&
                            !response.data[0].id &&
                            response.data[0].title ===
                            "You are trying to add more owners than allowed"
                        ) {
                            this.setalertparameters(
                                `<div>${addOwnerError0.replace(
                                    "{count}",
                                    `${this.state.addLicenses + 5}`
                                )}  </div><br />${addOwnerError1}`,
                                "error",
                                "Error"
                            );
                        } else {
                            if (skippedEmailsCount > 0 || UpdatedEmailsCount > 0) {
                                this.setalertparameters(
                                    `${skippedEmailsCount > 0 && response.data.length > 0
                                        ? Object.entries(accessTypeCounts)
                                            .map(([type, count]) => `<div><div>${addOwnerSkippedSuccess
                                            .replace("{count}", `${count}`)
                                            .replace("{type}", type)}</div>`)
                                        .join('')
                                        : ""
                                    }${UpdatedEmailsCount > 0
                                        ? `<div>${addRemovedMemberOwnerSuccess
                                            .replace("{count}", UpdatedEmailsCount)}`
                                        : ""
                                    } <div>${addOwnerSuccess
                                        .replace("{count}", `${addedEmailsCount}`)
                                        .replace("{type}", type)}`,
                                    "success",
                                    "Success"
                                );
                            }
                            this.setState(
                                {
                                    members: [
                                        {
                                            firstName: "",
                                            lastName: "",
                                            displayname: "",
                                            email: "",
                                            country: "",
                                            company: "",
                                            speakersGroup: "false",
                                            attendeesGroup: "false",
                                            organizersGroup: "false",
                                            sponsersGroup: "false",
                                            IsEdited: false,
                                        },
                                    ],
                                    keychanged: true,
                                },
                                () => {
                                    this.tableRef?.current?.forceUpdateGrid();
                                }
                            );
                        }
                        if (this.uploadedFileRef && this.uploadedFileRef.current)
                            this.uploadedFileRef.current.value = "";
                        if (UpdatedEmailsCount > 0) {
                            this.loadTeamInfo("All");
                        } else {
                            this.loadTeamInfo(`${type}s`);
                        }
                        this.setState({ loading: false, addRemoved: false });
                    } else {
                        this.setalertparameters(`${addMemberError}`, "error", "Error");
                    }
                });
            } else {
                this.setState({ loading: false });
            }
        } catch {
            this.setalertparameters(`${addMemberError}`, "error", "Error");
        }
    }

    exportToCSV(fileName: string) {
        try {
            let rows = [
                [
                    "First Name",
                    "Last Name",
                    "Display Name",
                    "Email",
                    "Country",
                    "Company",
                    "Speakers Group",
                    "Attendees Group",
                    "Organizers Group",
                    "Sponsors Group",

                ],
                ["", "", "", "", "", "", "No", "No", "No", "No"],
            ];
            if (fileName === "countries") {
                rows = [["Country"]]
                const countries = countryJson.countries.map(x => [x.displayName])
                rows = [...rows, ...countries]
            }
            let csvContent =
                "data:text/csv;charset=UTF-8,\ufeff" +
                rows.map((e) => e.join(",")).join("\n");
            const encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `${fileName}.csv`);
            document.body.appendChild(link);
            link.click();
        } catch {
            this.setalertparameters(`${CsvExportError}`, "error", "Error");
        }
    }

    getDisabled(members: any): boolean {
        let invalid = false;
        members.forEach((element: any) => {
            if (
                !element.firstName?.trim() ||
                element.duplicateemail ||
                !element.lastName?.trim() ||
                !element.displayname?.trim() ||
                !element.email ||
                (element.firstName && !regex.test(element.firstName)) ||
                (element.lastName && !lastnameregex.test(element.latName)) ||
                (element.email &&
                    (!(
                        emailregex.test(element.email) &&
                        emailRegexToCheckSpl.test(element.email)
                    ) ||
                        element.email.toLowerCase().includes("@" + `${tenantDomain}`))) ||
                (!element.company && companyRequired) ||
                element.firstName.length > 255 ||
                element.lastName.length > 255 ||
                element.email.length > 255 ||
                element.displayname.length > 64 ||
                element.country.length > 255 ||
                element.company.length > 64
            ) {
                invalid = true;
            }
        });
        if (this.state.loading || this.state.members.length === 0 || invalid) {
            return true;
        } else {
            return false;
        }
    }

    onResetGroupId() {
        this.setState({ selectedgroupid: "", keychanged: true });
    }

    async loadTeamInfo(userType: string) {
        const { selectedgroupid } = this.state;
        this.handleLoading(true);

        if (userType === "All") {
            await GetAccountsMembersAndOwners(selectedgroupid).subscribe(
                (allData: any) => {
                    if (allData.status === "Error") {
                        this.setalertparameters(allData.message, "error", "Error");
                        this.handleLoading(false);
                    } else {
                        this.setState(
                            {
                                groupOwners: allData.owners,
                                groupMembers: allData.members,
                            },
                            () => this.mapAccountsToUsers()
                        );
                    }
                }
            );
        } else if (userType === "Members") {
            await GetAccountsMembers(selectedgroupid).subscribe(
                (membersData: any) => {
                    if (membersData.status === "Error") {
                        this.setalertparameters(membersData.message, "error", "Error");
                        this.handleLoading(false);
                    } else {
                        this.setState(
                            {
                                groupMembers: membersData.members,
                            },
                            () => this.mapAccountsToUsers()
                        );
                    }
                }
            );
        } else if (userType === "Owners") {
            await GetAccountsOwners(selectedgroupid).subscribe((ownersData: any) => {
                if (ownersData.status === "Error") {
                    this.setalertparameters(ownersData.message, "error", "Error");
                    this.handleLoading(false);
                } else {
                    this.setState(
                        {
                            groupOwners: ownersData.owners,
                        },
                        () => this.mapAccountsToUsers()
                    );
                }
            });
        }
    }

    mapAccountsToUsers() {
        const { groupMembers, groupOwners } = this.state;
        this.setState({
            removedGroupMembers: groupMembers.filter(
                (member: any) =>
                    member.status === "Removed"
            ),
            removedGroupOwners: groupOwners.filter(
                (member: any) =>
                    member.status === "Removed"
            ),
            ownersCount: groupOwners.filter(
                (owner: any) => owner.status !== "Removed"
            ).length,
        });
        this.handleLoading(false);
    }

    findCountryNameFromList(name: string) {
        let country = null;
        if (name) {
            if (name.length === 2)
                country = countryJson.countries.find(
                    (country) => country.countryCode.toLowerCase() === name.toLowerCase()
                );
            else
                country = countryJson.countries.find(
                    (country) => country.displayName.toLowerCase() === name.toLowerCase()
                );
            if (country) return country.displayName;
            return "Not Found";
        }
        return "";
    }

    async setGroupid(selectedTeam: any, addLicenses: number) {
        this.setState(
            {
                selectedgroupid: selectedTeam?.teamGUID,
                selectedGroup: selectedTeam,
                addLicenses: addLicenses,
            },
            () => {
                this.tableRef?.current?.forceUpdateGrid();
                this.loadTeamInfo("All");
            }
        );
    }

    copyToClipBoard = () => {
        if (this.state.accept !== undefined) {
            console.log(this.state.selectedgroupid);
            console.log(window.btoa(this.state.selectedgroupid));
            let copyString = "";
            if (
                this.state.selectedgroupid &&
                this.state.selectedgroupid.length !== 0
            ) {
                copyString =
                    `${copyStringLink}` + window.btoa(this.state.selectedgroupid);
                let hiddenTextArea = document.createElement("textarea");
                document.body.appendChild(hiddenTextArea);
                hiddenTextArea.value = copyString;
                hiddenTextArea.select();
                document.execCommand("copy");
                document.body.removeChild(hiddenTextArea);
                this.setalertparameters(
                    `${selfServiceMemberAddSuccess}`,
                    "success",
                    "Success"
                );
            } else
                this.setalertparameters(`${notSelectedTeamError}`, "error", "Error");
            return;
        }
    };

    async setalertparameters(
        message: string,
        type: string = "warning",
        heading: string = "Warning"
    ) {
        this.setState({
            loading: false,
            alertmessage: message,
            alerttype: type,
            alertheading: heading,
            showalert: true,
        });
    }

    findCountryCodeFromList(name: string) {
        let country = null;
        if (name) {
            if (name.length === 2)
                country = countryJson.countries.find(
                    (country) => country.countryCode.toLowerCase() === name.toLowerCase()
                );
            else
                country = countryJson.countries.find(
                    (country) => country.displayName.toLowerCase().replace(/[^a-zA-Z 0-9]+/g, "") === name.toLowerCase().replace(/[^a-zA-Z 0-9]+/g, "")
                );
            if (country) return country.countryCode;
            return "Not Found";
        }
        return "";
    }

    findCountryCodeFromListNew(name: string) {
        let country = null;
        if (name) {
            if (name.length === 2)
                country = countryJson.countries.find(
                    (country) => country.countryCode.toLowerCase() === name.toLowerCase()
                );
            else
                country = countryJson.countries.find(
                    (country) => country.displayName.toLowerCase() === name.toLowerCase()
                );
            if (country) return country.countryCode;
            return "Not Found";
        }
        return "";
    }

    getEmailValidationError(email: string, duplicateemail: boolean, memIndex: number) {
        if (email && !(emailregex.test(email) && emailRegexToCheckSpl.test(email)))
            return <span className="email-validation">{emailInvalidValidError}</span>;
        else if (email && email.toLowerCase().includes("@" + `${tenantDomain}`))
            return (
                <span className="email-validation">{emailWithTenantDomainError.replace("{tenantDomain}", tenantDomain)}</span>
            );
        else if (email && duplicateemail)
            return <span className="email-validation">{emailDuplicateError}</span>;
        else if (email && email.length > 255)
            return (
                <span className="email-validation">{emailInvalidLengthError}</span>
            );
        else if (!email)
            return (
                <span className="email-validation">{emailRequiredError}</span>
            );
        return "";
    }

    getNameValidationError(name: string, key: string, memIndex: number) {
        if (name && name.length > 255) {
            return (
                <span className="email-validation">
                    {key === "First Name" ? firstNameLength : lastNameLength}
                </span>
            );
        } else if (name && key === "First Name" && !regex.test(name)) {
            return (
                <span className="email-validation">
                    {firstNameInvalidValidError}
                </span>
            );
        } else if (name && key === "Last Name" && !lastnameregex.test(name)) {
            return (
                <span className="email-validation">
                    {lastNameInvalidValidError}
                </span>
            );
        }
        else if (!name) {
            return (
                <span className="email-validation">
                    {key === "First Name"
                        ? firstNameRequiredError
                        : lastNameRequiredError}
                </span>
            );
        }
        return "";
    }

    addMembers(title: string) {
        const { members } = this.state;
        let orginalevents = Object.assign({}, members);
        let currentData: Array<any> = [];
        let toindex = this.state.selectedPage * this.state.pageSize;
        let fromindex = toindex - this.state.pageSize;
        for (let i = fromindex; i < toindex; i++) {
            if (orginalevents[i]) {
                currentData = [...currentData, { ...orginalevents[i], memberIdex: i }];
            }
        }
        return (
            <div className="mt-3 mb-2 card cd2">
                <table className="table table-responsive">
                    <thead className="thead-light">
                        <tr id={"scroll-to-bottom"} className="memberlistheader">
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Display Name</th>
                            <th>Email</th>
                            <th>Country</th>
                            <th>Company</th>
                            <th>Speakers Group</th>
                            <th>Attendees Group</th>
                            <th>Organizers Group</th>
                            <th>Sponsors Group</th>
                            {members.length > 0 && (
                                <th style={{ color: "#e9ecef" }}>Delete</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.map((member: any, index: number) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control fc text-capitalize	"
                                        value={member.firstName}
                                        placeholder="First Name"
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "firstName",
                                                event.target.value
                                            )
                                        }
                                        disabled={!this.state.selectedgroupid}
                                    />
                                    {this.getNameValidationError(member.firstName, "First Name", index)}
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control fc text-capitalize	"
                                        value={member.lastName}
                                        placeholder="Last Name"
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "lastName",
                                                event.target.value
                                            )
                                        }
                                        disabled={!this.state.selectedgroupid}
                                    />
                                    {this.getNameValidationError(member.lastName, "Last Name", index)}
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control fc"
                                        value={member.displayname}
                                        placeholder="Display Name"
                                        required={true}
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "displayname",
                                                event.target.value
                                            )
                                        }
                                        disabled={!this.state.selectedgroupid}
                                    />
                                    {member.displayname && member.displayname.length > 64 && (
                                        <p className="email-validation">{displayNameLength}</p>
                                    )}
                                    {!member.displayname && (
                                        <p className="email-validation">{displayNameRequiredError}</p>
                                    )}
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control fc"
                                        value={member.email}
                                        placeholder="Email Id"
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "email",
                                                event.target.value
                                            )
                                        }
                                        disabled={!this.state.selectedgroupid}
                                    />
                                    {this.getEmailValidationError(
                                        member.email,
                                        member.duplicateemail, index
                                    )}
                                </td>
                                <td>
                                    <select
                                        className="form-control fc"
                                        id="country"
                                        value={member.country}
                                        disabled={!this.state.selectedgroupid}
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "country",
                                                event.target.value
                                            )
                                        }

                                        aria-label="select country"
                                    >
                                        <option value="">Select</option>
                                        {(countryJson.countries || []).map((value, id) => (
                                            <option key={id} value={value.countryCode}>
                                                {value.displayName}
                                            </option>
                                        ))}
                                    </select>
                                    {this.findCountryNameFromList(member.country) ===
                                        "Not Found" &&
                                        this.findCountryCodeFromList(member.country) ===
                                        "Not Found" ? (
                                        <span className="email-validation">
                                            {countryNotFoundError}
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control fc text-capitalize	"
                                        value={member.company}
                                        placeholder="Company"
                                        onChange={(event) =>
                                            this.setMemberProperty(
                                                member.memberIdex,
                                                "company",
                                                event.target.value
                                            )
                                        }
                                        disabled={!this.state.selectedgroupid}
                                    />
                                    {member.company && member.company.length > 64 && (
                                        <p className="email-validation">
                                            {companyLength}
                                        </p>
                                    )}
                                    {!member.company && companyRequired && (
                                        <p className="email-validation">
                                            {companyRequiredError}
                                        </p>
                                    )}
                                </td>
                                <td>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={member.speakersGroup === "true" ? true : false}
                                            onChange={(event) =>
                                                this.setMemberProperty(
                                                    member.memberIdex,
                                                    "speakersGroup",
                                                    event.target.checked.toString()
                                                )
                                            }
                                            disabled={!this.state.selectedgroupid}
                                            aria-label={'speakers group checkbox' + member.memberIdex}
                                        />
                                        <span></span>
                                    </label>
                                </td>
                                <td>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={member.attendeesGroup === "true" ? true : false}
                                            onChange={(event) =>
                                                this.setMemberProperty(
                                                    member.memberIdex,
                                                    "attendeesGroup",
                                                    event.target.checked.toString()
                                                )
                                            }
                                            disabled={!this.state.selectedgroupid}
                                            aria-label={'attendees group checkbox' + member.memberIdex}
                                        />
                                        <span className="mt"></span>
                                    </label>
                                </td>
                                <td>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={member.organizersGroup === "true" ? true : false}
                                            onChange={(event) =>
                                                this.setMemberProperty(
                                                    member.memberIdex,
                                                    "organizersGroup",
                                                    event.target.checked.toString()
                                                )
                                            }
                                            disabled={!this.state.selectedgroupid}
                                            aria-label={'organizers group checkbox' + member.memberIdex}
                                        />
                                        <span className="mt"></span>
                                    </label>
                                </td>
                                <td>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={member.sponsersGroup === "true" ? true : false}
                                            onChange={(event) =>
                                                this.setMemberProperty(
                                                    member.memberIdex,
                                                    "sponsersGroup",
                                                    event.target.checked.toString()
                                                )
                                            }
                                            disabled={!this.state.selectedgroupid}
                                            aria-label={'sponsers group checkbox-' + member.memberIdex}
                                        />
                                        <span className="mt"></span>
                                    </label>
                                </td>
                                {members.length === 1 && (
                                    <td>
                                        <button
                                            style={{ background: "#dcdce3" }}
                                            className="Primary addmem"
                                            disabled
                                        >
                                            Delete
                                        </button>
                                    </td>
                                )}
                                {members.length > 1 && (
                                    <td>
                                        <button
                                            className="Primary addmem"
                                            onClick={() => this.removeMember(member.memberIdex)}
                                            disabled={!this.state.selectedgroupid}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="page-nav">
                    <select
                        value={this.state.pageSize}
                        className="selectrows"
                        onChange={(event: any) =>
                            this.setState({
                                pageSize: event.target.value,
                                selectedPage: 1,
                            })
                        }
                        aria-label="select number of rows to display"
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50 ">50</option>
                        <option value="100">100</option>
                    </select>
                    {this.state.members.length > 0 &&
                        this.state.members?.length > this.state.pageSize && (
                            <PaginationComponent
                                totalItems={this.state.members?.length}
                                pageSize={this.state.pageSize}
                                onSelect={(selectedPage) => this.setState({ selectedPage })}
                                defaultActivePage={this.state.selectedPage}
                            />
                        )}
                </div>
                {members[members.length - 1].firstName !== "" &&
                    members[members.length - 1].lastName !== "" &&
                    members[members.length - 1].displayname !== "" &&
                    members[members.length - 1].email !== "" && (
                        <button className="Primary addrow" onClick={this.addRow}>
                            Add More
                        </button>
                    )}
                <input
                    id="uploadFile"
                    type="file"
                    accept=".csv"
                    className="file"
                    ref={this.uploadedFileRef}
                    onChange={(evt: any) => this.handleFiles(evt.target.files[0])}
                    disabled={!this.state.selectedgroupid}
                    aria-label="input upload file"
                />
                <button className="sampleref" onClick={() => this.exportToCSV("members")}>
                    Click here to download sample csv file
                </button>
                <button className="sampleref" onClick={() => this.exportToCSV("countries")}>
                    Click here to download countries list
                </button>
                <br />
                <button
                    disabled={this.state.keychanged || !this.state.selectedgroupid}
                    style={{
                        cursor:
                            this.state.keychanged || !this.state.selectedgroupid
                                ? "not-allowed"
                                : "pointer",
                        background:
                            this.state.keychanged || !this.state.selectedgroupid
                                ? "lightgray"
                                : "",
                    }}
                    className="Primary"
                    onClick={this.postData}
                    title={
                        this.state.keychanged || !this.state.selectedgroupid
                            ? "Please select team, add members & guests and check invalid fields before submit"
                            : "Submit your team members"
                    }
                >
                    Submit
                </button>
                {this.state.showalert && (
                    <CAlert
                        message={this.state.alertmessage}
                        heading={this.state.alertheading}
                        type={this.state.alerttype}
                        closecallback={() => this.setState({ showalert: false })}
                    />
                )}
            </div>
        );
    }

    viewMembers(title: string) {
        return (
            <div className="legend" style={{ width: "100%" }}>
                <span className="expandheader" onClick={this.showContent}>
                    {this.state.showcontent === "show" ? "-" : "+"}
                    <span className="collapsible">
                        <b>View {title} Instructions</b>
                    </span>
                </span >
                {
                    this.state.showcontent === "show" && (
                        <div className="content">
                            <b>Status Guide: </b>
                            <ul>
                                <li>
                                    Submitted: We have received the request and are working on it.
                                </li>
                                <li>
                                    Processed: The account is being processed in the backend. No actions are available during this stage. Typically this completes within a few minutes.
                                </li>
                                <li>
                                    Enabled: The account is ready for use. During this stage you will be able to edit the users information including their group memberships, remove them from the Team, and you can resend the Member's credentials or guest invitation via email.
                                </li>
                                <li>
                                    Removed: The account has been removed. Removed Accounts can be re-added.
                                </li>
                            </ul>
                            <b>Groups: </b>
                            <p className="groups">
                                We have pre-created 4 mail enabled security groups for your convenience.  These groups are to help you manage your Team and can be used to send emails to specific groups of people.
                            </p>
                            {title !== "Owners" && (
                                <div>
                                    <b>To select {title} in bulk, please do the following:</b>
                                    <ul>
                                        <li>
                                            Click the Bulk Select button.
                                        </li>
                                        <li>
                                            Download the sample csv file from the link in the Bulk Select popup, and open in Excel or your text editor of choice.
                                        </li>
                                        <li>
                                            Retain the header row without any changes.
                                        </li>
                                        <li>
                                            Add additional rows after the header with the UPN values - one line per account to be selected.  
                                            The UPN values can be found in the list here or a csv from the Export button.
                                        </li>
                                        <li>
                                            Save the file as a "CSV UTF-8" file type (do not change format).
                                        </li>
                                        <li>
                                            Upload the file using the form in the Bulk Select popup.
                                        </li>
                                    </ul>  
                                </div>      
                            )}
                        </div>
                    )
                }
            </div >
        );
    }

    addMembersText(title: string) {
        return (
            <div className="legend">
                <span className="expandheader" onClick={this.showContent}>
                    {this.state.showcontent === "show" ? "-" : "+"}
                    <span className="collapsible">
                        <b>Add {title} Instructions</b>
                    </span>
                </span >
                {
                    this.state.showcontent === "show" && (
                        <div className="content">
                            <ul>
                                <li>
                                    Use an existing external email (not their {`${tenantDomain}`} account) for email. If the Member already has a {`${tenantDomain}`} account they will be added to your Team using their existing account. If the Member does not have a {`${tenantDomain}`} account they will be added to your Team as a Guest.
                                </li>
                                <li>
                                    Members will receive information on accessing the Team via email. Please allow up to 48 hours for for full access to the Team.
                                </li>
                                <li>
                                    To view the status of a Member's account and edit their details, click the 'View Members & Guests' tab.
                                </li>
                                <li>
                                    Adding a country is optional.  If no country is provided, United States will be listed as default. Specifying a country will change the default call in number for any meeting organized by that user.
                                </li>
                                <li>
                                    Use the Group checkboxes to control membership in the precreated mail-enabled security groups. These groups can be used to send email from any {`${tenantDomain}`} email account.
                                </li>
                            </ul>
                            <p>More information on adding Members and Owners to your team can be found in the <a href={`${amtDocsUrl}`} target="_blank" rel="noopener noreferrer">Account Management Tool documentation</a>.</p>

                            {this.state.showbulkcontent === "show" && (
                                <div>
                                    <b>To add {title} in bulk, please do the following:</b>
                                    <div className="content">
                                        <ul>
                                            <li>
                                                Download the sample csv file from the link below and open in Excel.
                                            </li>
                                            <li>
                                                Retain the header row without any changes.
                                            </li>
                                            <li>
                                                Add additional rows after the header with the proper values for each column - one line per user to be added. Do not include previously submitted users.
                                            </li>
                                            <li>
                                                If you choose to assign a country to your user, please provide one from the countries list using the link below.
                                            </li>
                                            <li>
                                                If you choose to assign mail enabled security groups use Yes as the value.
                                            </li>
                                            <li>
                                                Save the file as a "CSV UTF-8" file type (do not change format to Excel).
                                            </li>
                                            <li>
                                                Upload the file using the form below.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                }
            </div >
        );
    }

    selfServiceText(title: string) {
        return (
            <div className="selfService">
                <div className="">
                    <p>
                        Sending this URL to users will allow them to fill out their details and add themselves directly to your Team. Anyone with this link can become a guest in your team without any additional action or verification by you - please distribute with care. Guests can be removed from your Team at a later date using the View Members & Guests tab.
                    </p>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                            this.copyToClipBoard();
                        }}
                        className="self-service-copy-btn"
                    >
                        Copy Link
                    </Button>
                </div>
            </div>
        );
    }

    addOwnersText(title: string) {
        return (
            <div className="legend">
                <span className="expandheader" onClick={this.showContent}>
                    {this.state.showcontent === "show" ? "-" : "+"}
                    <span className="collapsible">
                        <b>Add {title} Instructions</b>
                    </span>
                </span >
                {
                    this.state.showcontent === "show" && (
                        <div className="content">
                            <ul>
                                <li>
                                    Use this tab to create local {`${tenantDomain}`} account for users who will help to manage your Team as owners. By adding a user as an owner here you are granting them the same permission as you have, including access to this tool &amp; all other owner management tools.
                                </li>
                                <li>
                                    Each Team is entitled to Five E5 Tenant Licenses for owners to manage and moderate the Team.
                                </li>
                                <li>
                                    Use an existing external email (not their {`${tenantDomain}`} account) for email. If the Owner already has a {`${tenantDomain}`} account they will be added to your Team using their existing account. If the Owner does not have a {`${tenantDomain}`} account a new one will be created.
                                </li>
                                <li>
                                    If the user already has a {`${tenantDomain}`} account they will be added to your Team using the existing account.
                                </li>
                                <li>
                                    Owners will receive information on accessing the Team via email. Please allow up to 48 hours for for full access to the Team.
                                </li>
                                <li>
                                    To view the status of an Owners's account and edit their details, click the 'View Owners' tab.
                                </li>
                                <li>
                                    Adding a country is optional. If no country is provided, United States will be listed as default. Specifying a country will change the default call in number for any meeting organized by that user.
                                </li>
                                <li>
                                    Use the Group checkboxes to control membership in the precreated mail-enabled security groups. These groups can be used to send email from any {`${tenantDomain}`} email account.
                                </li>
                            </ul>
                            <p>More information on adding Members and Owners to your team can be found in the <a href={`${amtDocsUrl}`} target="_blank" rel="noopener noreferrer">Account Management Tool documentation</a>.</p>
                            {this.state.showbulkcontent === "show" && (
                                <div>
                                    <b>To add {title} in bulk, please do the following:</b>
                                    <div className="content">
                                        <ul>
                                            <li>
                                                Download the sample csv file from the link below and open in Excel.
                                            </li>
                                            <li>
                                                Retain the header row without any changes.
                                            </li>
                                            <li>
                                                Add additional rows after the header with the proper values for each column - one line per user to be added. Do not include previously submitted users.
                                            </li>
                                            <li>
                                                If you choose to assign a country to your user, please provide one from the countries list using the link below.
                                            </li>
                                            <li>
                                                If you choose to assign mail enabled security groups use Yes as the value.
                                            </li>
                                            <li>
                                                Save the file as a "CSV UTF-8" file type (do not change format to Excel).
                                            </li>
                                            <li>
                                                Upload the file using the form below.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                }
            </div >
        );
    }

    handleLoading(isLoading: boolean) {
        this.setState({ loading: isLoading });
    }

    renderWarningModal() {
        return (
            <Modal show={this.state.showWarning} size="sm">
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">Warning!</Modal.Title>
                </Modal.Header>
                <Modal.Body className="no-height">
                    Accepting by pressing Yes will navigate you to the self service
                    portal. Are you sure you wish to proceed?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => this.handleWarning(false)}>
                        No
                    </Button>
                    <Button variant="secondary" onClick={() => this.handleWarning(true)}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleWarning(value: boolean) {
        if (value) {
            this.postSelfAcceptance();
        }
        this.showWarning(false);
    }

    showWarning(show: boolean) {
        this.setState({ showWarning: show });
    }
    acceptSelf(accept: boolean) {
        this.setState({ accept }, () => {
            if (this.state.accept !== undefined) {
                this.postSelfAcceptance();
            } else {
                alert("Please select Accept or Decline to submit");
            }
        });
    }

    async postSelfAcceptance() {
        if (this.state.accept !== undefined) {
            console.log(this.state.selectedgroupid);
            console.log(window.btoa(this.state.selectedgroupid));
            let params = `height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no`;

            if (
                this.state.selectedgroupid &&
                this.state.selectedgroupid.length !== 0
            ) {
                window.open(
                    `${copyStringLink}` + window.btoa(this.state.selectedgroupid),
                    "test",
                    params
                );
            } else
                this.setalertparameters(`${notSelectedTeamError}`, "error", "Error");
            return;
        }
    }

    render() {
        return (
            <div>
                <Header isTos={false} />
                <Tabs
                    defaultActiveKey="Add Members & Guests"
                    id=""
                    className="sidebar-pf sidebar-pfcustom"
                    onSelect={(eventKey) =>
                        this.setState({
                            activeTab: eventKey,
                            members: [
                                {
                                    firstName: "",
                                    lastName: "",
                                    displayname: "",
                                    email: "",
                                    country: "",
                                    company: "",
                                    speakersGroup: "false",
                                    attendeesGroup: "false",
                                    organizersGroup: "false",
                                    sponsersGroup: "false",
                                },
                            ],
                        })
                    }
                >
                    <Tab eventKey="Add Members & Guests" title="Add Members & Guests"></Tab>
                    <Tab eventKey="View Members & Guests" title="View Members & Guests"></Tab>
                    <Tab eventKey="Add Owners" title="Add Owners"></Tab>
                    <Tab eventKey="View Owners" title="View Owners"></Tab>
                </Tabs>
                <div className="tabsdata tabledatacustom">
                    {this.state.activeTab === "Add Members & Guests" && (
                        <React.Fragment>{this.addMembersText("Members & Guests")}</React.Fragment>
                    )}
                    {this.state.activeTab === "View Members & Guests" && (
                        <React.Fragment>{this.viewMembers("Members & Guests")}</React.Fragment>
                    )}
                    {this.state.activeTab === "Add Owners" && (
                        <React.Fragment>{this.addOwnersText("Owners")}</React.Fragment>
                    )}
                    {this.state.activeTab === "View Owners" && (
                        <React.Fragment>{this.viewMembers("Owners")}</React.Fragment>
                    )}
                    <TeamList
                        resetGroupId={this.onResetGroupId}
                        parentselectedgroupid={this.state.selectedgroupid}
                        parentCallback={this.setGroupid}
                        setalertparameters={this.setalertparameters}
                        styleName={`input-group mt-3`}
                        availableOwners={this.state.ownersCount}
                        addLicenses={this.state.activeTab.toLowerCase().includes("owners")}
                        loading={this.state.loading}
                    />
                    {typeof notSeeingTeamsInfo != 'undefined' && notSeeingTeamsInfo.trim() && (
                        <React.Fragment>
                            <div className="selfService">
                                <div className="">
                                    <p dangerouslySetInnerHTML={{ __html: notSeeingTeamsInfo }} style={{ margin: 0 }}>
                                    </p>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    {this.state.activeTab === "Add Members & Guests" && (
                        <React.Fragment>{this.selfServiceText("Members")}</React.Fragment>
                    )}
                    {this.state.activeTab.toLowerCase().includes("view members & guests") && (
                        <MembersList
                            loadingCallBack={this.handleLoading}
                            memList={"Members"}
                            addLicenses={false}
                            parentselectedGroupid={this.state.selectedgroupid}
                            postOwnersCount={(owners: Array<any>) =>
                                this.getOwnerCount(owners)
                            }
                            selectedGroup={this.state.selectedGroup}
                            data={this.state.groupMembers}
                            onUsersUpdate={this.loadTeamInfo}
                        />
                    )}
                    {this.state.activeTab.toLowerCase().includes("view owners") && (
                        <MembersList
                            loadingCallBack={this.handleLoading}
                            memList={"Owners"}
                            addLicenses={true}
                            parentselectedGroupid={this.state.selectedgroupid}
                            postOwnersCount={(owners: Array<any>) =>
                                this.getOwnerCount(owners)
                            }
                            selectedGroup={this.state.selectedGroup}
                            data={this.state.groupOwners}
                            onUsersUpdate={this.loadTeamInfo}
                        />
                    )}
                    {this.state.activeTab.toLowerCase().includes("add") &&
                        this.addMembers(
                            this.state.activeTab.toLowerCase().includes("members")
                                ? "Members"
                                : "Owners"
                        )}
                    {this.state.loading && (
                        <div className="container1">
                            <img src={logo} className="page-loader loader" alt=""></img>
                        </div>
                    )}
                </div>
                <Modal
                    size="sm"
                    show={this.state.addRemoved}
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            Confirmation
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            {addRemovedMemberOwnerConfirmation}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.handlePostMembers()}>
                            Yes
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                this.setState({ addRemoved: false });
                            }}
                        >
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                {this.renderWarningModal()}
            </div>
        );
    }
}
